import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import TrackerMap from './TrackerMap';
import Home from './Home';
import './App.css';
import ErrorBoundary from './ErrorBoundary';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Header minimal avec boutons séparés */}
        <header className="App-header">
          <Link to="/" className="nav-button">Home</Link>
          <Link to="/tracker" className="nav-button">TrackerMap</Link>
        </header>

        {/* Zone principale qui prend le reste de l’écran */}
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/tracker"
              element={
                <ErrorBoundary>
                  <TrackerMap />
                </ErrorBoundary>
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
